export enum Country {
  Canada = 1,
  UnitedStates = 2
}
